// extracted by css-extract-rspack-plugin
export default {"coloredIconRoot":"P4Xx8xiyaQkCxymB","coloredIcon":"X6UdM60zY4QaMLRS","unspecifiedIcon":"XsRsxLohn50HLxNK"};